import { Warning as WarningIcon } from '@mui/icons-material'
import React from 'react'

interface IPossibleTotalLossIconProps {
  possibleTotalLoss: boolean
}
function PossibleTotalLossIcon({
  possibleTotalLoss
}: IPossibleTotalLossIconProps) {

  if (!possibleTotalLoss) return <></>

  return (
    <WarningIcon
      fontSize='small'
      style={{
        color: '#fab01c',
        margin: '-5px 0 0 5px'
      }}
    />)
}

export { PossibleTotalLossIcon }